import BaseSobrevivenciaRequest from "../BaseSobrevivenciaRequest";
import FormularioRespuesta from "./FormularioRespuesta";

export default class SaveBeneficiarioRequest extends BaseSobrevivenciaRequest {
  constructor( 
    public canal: string = "PortalBE",
    public codUsuario: string = "",
    public numPreSolicitud: number= 0,
    public data : FormularioRespuesta[] = []
  ) {
    super(canal, codUsuario, numPreSolicitud);
  }
}
